import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import TaxReturn from './pages/TaxReturn/TaxReturn';
import ContactUs from './pages/ContactUs/ContactUs';
import AboutUs from './pages/AboutUs/AboutUs';
import Accounting from './pages/Accounting/Accounting';
import NotFound from './pages/NotFound';
import SydneyLocation from './pages/LocationPages/Sydney';
import MohaliLocation from './pages/LocationPages/Mohali';
import OrangeLocation from './pages/LocationPages/Orange';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <div className='App'>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/individual-tax-return' element={<TaxReturn />} />
          <Route path='/contact' element={<ContactUs />} />
          <Route path='/about' element={<AboutUs />} />
          <Route path='/accounting-services' element={<Accounting />} />
          <Route path='/location-sydney' element={<SydneyLocation />} />
          <Route path='/location-mohali' element={<MohaliLocation />} />
          <Route path='/location-orange' element={<OrangeLocation />} />

          {/* Catch-all route for 404 */}
          <Route path='*' element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
